import { createTranslationResource } from '@backstage/frontend-plugin-api';
import { searchReactTranslationRef } from '@backstage/plugin-search-react';

export const searchReactTranslations = createTranslationResource({
  ref: searchReactTranslationRef,
  translations: {
    'pt-BR': () => import('./pt-BR'),
  },
});
